import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import icoMoney from "../../../assets/img/ico-money.svg";

const Patrimonio = () => {

  const [patrimonio, setPatrimonio] = useState<any>();
  const [planoA, setPlanoA] = useState<any>();
  const [planoB, setPlanoB] = useState<any>();
  const [planoTaesa, setPlanoTaesa] = useState<any>();
  const [total, setTotal] = useState<any>();
  const [unidade, setUnidade] = useState<any>();
  useEffect(() => {
    api
      .get("/ObterInformacoesPlano")
      .then((response) => {

        setPatrimonio(response.data);

        response.data.results.map((item: any) => {

          if (item.NomePlano === "Plano A") {
            setPlanoA(item.AtivoLiquido);
          }

          if (item.NomePlano === "Plano B") {
            setPlanoB(item.AtivoLiquido);
          }

          if (item.NomePlano === "Plano Taesa") {
            setPlanoTaesa(item.AtivoLiquido);
          }

          return true;

        })

        setPatrimonio(response.data.results[1].DataReferencia);

      })
      .catch((err) => {
        throw new Error(err);
      });
  }, []);
  useEffect(() => {
    api
      .get("/ObterCamposGerais")
      .then((response) => {

        setTotal(response.data.results[0].PatrimonioTotal);

        setUnidade(response.data.results[0].valorInfo);

      })
      .catch((err) => {
        throw new Error(err);
      });
  }, []);

  function formatDateAno(dateUtc: any) {

    if (dateUtc) {
      return new Date(dateUtc).getDate() + ' / ' + new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' }).toString() + ' / '
        + new Date(dateUtc).getFullYear().toString();
    }
  }

  function formatLargeNumber(value: any, args: any) {

    if (!value) {
      return null;
    }

    if (Number.isNaN(value)) {
      return null;
    }

    if (value < 1000) {
      return value;
    }

    const exp = Math.floor(Math.log(value) / Math.log(1000));

    const returnValue = (value / Math.pow(1000, exp)).toFixed(args);

    return returnValue.toString().replace('.', ',');

  }

  return (

    <div className="row justify-content-center align-items-center">

      <div className="col-lg-4">
        <div className="col-md-6 col-lg-7 mb-5">

          <span className="text-medium font-14">Data de Referência: <br/> {formatDateAno(patrimonio)} </span>
        </div>
        <div className="page-numeros__patrimonio text-center text-white flex-column mx-auto ml-lg-0">
          <span>
            <img src={icoMoney} alt="ícone" />
            PATRIMÔNIO
          </span>
          <div>
            <p className="valor">{formatLargeNumber(total, 2)} </p>
            <p className="info2"> {unidade} </p>
          </div>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="page-numeros__desc mt-6 mt-lg-0">
          <div>

            <div className="line">
              <p><strong> Plano A </strong> <br /> {planoA?.toLocaleString('pt-BR')} </p>
              <p><strong> Plano B </strong> <br /> {planoB?.toLocaleString('pt-BR')} </p>
              <p><strong> Plano Taesa </strong> <br /> {planoTaesa?.toLocaleString('pt-BR')} </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};
export default Patrimonio;

